module.exports = __webpack_public_path__ + "img/way.c9f39281.png";